import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import router from "./router";
import setRem from "@/utils/setRem";
import ElementUI from "/lib/element-ui/index";
import "/lib/element-ui/theme-chalk/index.css";
import "@/assets/style/reset.css";
import "@/assets/style/index.scss";
import "@icon-park/vue/styles/index.css";
import "@/assets/iconfont/iconfont.css";
import * as filters from "@/filters/index.js";
import { initDict } from "@/utils/localDict";
//引入自定义指令，方便全局使用
import myDirective from "@/utils/directive.js";
import { qfw } from "@/utils/tool";
import day from "@/utils/day";
import watermark from 'watermark-dom'
Vue.use(watermark);
Vue.use(myDirective);
Vue.use(ElementUI);
//echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
Vue.prototype.$day = day;
Vue.prototype.$q = qfw;
Vue.config.productionTip = false;
setRem();
Vue.prototype.$dict = initDict();
Vue.prototype.$bus = new Vue();
//引入filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

const commonFn = (el, binding) => {
  const key = binding.value;
  if (key) {
    if (localStorage.getItem("permissions")) {
      const arr = JSON.parse(localStorage.getItem("permissions"));
      if (arr.indexOf(key[0]) === -1) {
        el && el.parentNode && el.parentNode.removeChild(el);
      }
    }
  }
};

// 权限-自定义指令
Vue.directive("limitUser", {
  inserted: commonFn,
  update: commonFn // 在某些地方同时通过v-if绑定dom元素，所以需要在if条件判断后即元素更新时再次执行
});

Vue.directive("noNull", {
  inserted: function (el) {
    if (!el.innerText) {
      el.innerHTML = "/";
    }
  }
});

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount("#app");
